import React from 'react';
import { CheckIcon } from 'lucide-react';
import { ENTERPRISE_CAPABILITIES } from '../../data/platform';
import { Reveal } from '../ui/Reveal';

/** Compact grid of enterprise capabilities. */
export function CapabilityGrid({
  showBody = true
}: {
  showBody?: boolean;
}) {
  return <ul className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-id="element-796" data-mp="2oddeoomzztsx">
      {ENTERPRISE_CAPABILITIES.map((capability, index) => <Reveal key={capability.label} as="li" delay={index % 4 * 0.03} className="flex gap-3 rounded-xl border border-hairline bg-panel p-4" data-id="element-797" data-mp="32btt71r3qolm" data-mpi={index}>
          <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-violet-soft text-lime" data-id="element-798" data-mp="2y9qd1zthmvu0">
            <CheckIcon className="h-3.5 w-3.5" strokeWidth={2.5} aria-hidden="true" data-id="element-799" data-mp="373cx4soc2and" />
          </span>
          <div data-id="element-800" data-mp="3m0m42uq4dn07">
            <p className="text-[15px] font-semibold text-text-primary" data-id="element-801" data-mp="3m26woesvivvf">{capability.label}</p>
            {showBody ? <p className="mt-0.5 text-sm leading-relaxed text-text-secondary" data-id="element-802" data-mp="3h3c5aogubyzp">{capability.body}</p> : null}
          </div>
        </Reveal>)}
    </ul>;
}